module.exports = __webpack_public_path__ + "img/caselist17.d63322a9.jpg";